export default "__VITE_ASSET__Brr50SRM__"